<ul class="c-icon-tooltip-list">
  <!-- (1.1.62) Wi-Fiサービス有無 -->
  <li *ngIf="wifiTooltipContent.wifiAlt && wifiTooltipContent.wifiIcon" class="c-icon-tooltip-list__item js-tooltip">
    <!-- ※Wi-Fiサービスに関する情報をツールチップ表示可能とする。-->
    <asw-tooltip
      [iconImage]="
        tripSummarySvc.buildTooltipIcon(wifiTooltipContent.wifiIcon, wifiTooltipContent.wifiAlt! | staticMsg)
      "
      [tooltipContent]="wifiTooltipContent.wifiAlt! | staticMsg"
    ></asw-tooltip>
  </li>
</ul>
